module.exports = __webpack_public_path__ + "img/fulfillment.4f7df9f6.svg";